/** Credit package amounts in EUR cents (Stripe unit_amount). */
export interface CreditPackagePricing {
  id: string;
  credits: number;
  price: number;
  originalPrice: number | null;
  pricePerCredit: number;
  discount: number | null;
}

export const CREDIT_PACKAGE_PRICING: CreditPackagePricing[] = [
  {
    id: "single",
    credits: 1,
    price: 3900, // €39.00
    originalPrice: null,
    pricePerCredit: 39,
    discount: null,
  },
  {
    id: "pack2",
    credits: 2,
    price: 6200, // €62.00 (2x €31.00)
    originalPrice: 7800, // €78.00 (2x €39.00)
    pricePerCredit: 31,
    discount: 20,
  },
  {
    id: "pack5",
    credits: 5,
    price: 11700, // €117.00 (5x €23.40)
    originalPrice: 19500, // €195.00 (5x €39.00)
    pricePerCredit: 23.4,
    discount: 40,
  },
];

export function getPackagePricing(id: string): CreditPackagePricing | undefined {
  return CREDIT_PACKAGE_PRICING.find((pkg) => pkg.id === id);
}

/** Resolve checkout prices from the catalogue, including links saved before repricing. */
export function getPackageForCredits(credits: number): CreditPackagePricing | undefined {
  return CREDIT_PACKAGE_PRICING.find((pkg) => pkg.credits === credits);
}
